// src/pages/roles/RolesPage.js

import React, { useMemo } from 'react'; // Keep useMemo import
import GenericListPage from '../GenericListPage';
import RoleForm from './RoleForm';

const roleColumns = [
  { header: 'ID', key: '_id', render: (role) => role._id.substring(0, 8) + '...' },
  { header: 'Role Name', key: 'name' },
  { header: 'Description', key: 'description' },
  { header: 'Permissions Count', key: 'permissions', render: (role) => role.permissions ? role.permissions.length : 0 },
];

const RolesPage = () => {
  // --- FIX: Move useMemo inside the functional component ---
  const roleFilterConfig = useMemo(() => [
    {
      name: 'name',
      type: 'text',
      label: 'Role Name',
    },
  ], []); // Empty dependency array means it's created once on mount

  return (
    <GenericListPage
      title="Roles"
      permission="manage_roles"
      entityEndpoint="roles"
      columns={roleColumns}
      FormComponent={RoleForm}
      filterConfig={roleFilterConfig}
    />
  );
};

export default RolesPage;
